var render = function render(){var _vm=this,_c=_vm._self._c;return _c('svg',{attrs:{"viewBox":"0 0 16 16","fill":"none","xmlns":"http://www.w3.org/2000/svg"}},[_c('path',{attrs:{"d":"M5.333 3h5.334v10H5.333V3Z","fill":"#ECEFF1"}}),_c('path',{attrs:{"d":"M10.667 3h4.666v10h-4.666V3Z","fill":"#FF3D00"}}),_c('path',{attrs:{"d":"M.667 3h4.666v10H.667V3Z","fill":"#689F38"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }